import { Box, Button, CircularProgress, InputAdornment, InputLabel } from '@material-ui/core';
import { InputPassword, PasswordIconTwoTone, Typography } from '@room-match/shared-ui-components';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { authDao } from 'shared/dao/authDao';
import { invitedUserSignup, selectUserState } from 'shared/redux/slicers/user.slicer';
import { getErrorMessage } from 'shared/utils/room-shared';
import { useStyles } from './AgencyRegistration.styles';
import { usePasswordForm } from './usePasswordForm';

interface Props {
  token: string;
}

const { resetPassword } = authDao();

const PasswordField: React.FC<Props> = ({ token: reset_password_token }) => {
  const dispatch = useDispatch();
  const classes = useStyles();

  const { isLoading } = useSelector(selectUserState);
  const history = useHistory();
  const { form } = usePasswordForm({
    onSubmit: async ({ password, password_confirmation }) => {
      dispatch(
        invitedUserSignup({ password, password_confirmation, reset_password_token, joined_via: 'talent_web' }, history),
      );
    },
  });

  return (
    <Box component="div" className={classes.formContainer}>
      <InputLabel>Password</InputLabel>
      <InputPassword
        autoComplete="off"
        className={classes.input}
        fullWidth
        name="password"
        onChange={(e) => {
          if (form.errors.password && !form.touched.password) {
            form.setFieldTouched('password');
            form.validateField('password');
          }
          //   form.setFieldValue('password_confirmation', e.target.value);
          return form.handleChange(e);
        }}
        errorMessage={getErrorMessage(form.touched.password, form.errors.password)}
        value={form.values.password}
        variant="outlined"
        placeholder="Type Password..."
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <PasswordIconTwoTone className={classes.startIcon} />
            </InputAdornment>
          ),
        }}
        InputLabelProps={{ shrink: true }}
        inputProps={{ tabIndex: 2 }}
        style={{ marginTop: '15px' }}
        onCopy={(e) => {
          e.preventDefault();
          return false;
        }}
        onPaste={(e) => {
          e.preventDefault();
          return false;
        }}
      />
      <InputLabel style={{ marginTop: 20 }}>Confirm Password</InputLabel>
      <InputPassword
        className={classes.input}
        name="password_confirmation"
        fullWidth
        onChange={(e) => {
          if (form.errors.password_confirmation && !form.touched.password_confirmation) {
            form.setFieldTouched('password_confirmation');
            form.validateField('password_confirmation');
          }
          return form.handleChange(e);
        }}
        errorMessage={getErrorMessage(form.touched.password_confirmation, form.errors.password_confirmation)}
        value={form.values.password_confirmation}
        variant="outlined"
        placeholder="Confirm Password..."
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <PasswordIconTwoTone className={classes.startIcon} />
            </InputAdornment>
          ),
        }}
        InputLabelProps={{ shrink: true }}
        inputProps={{ tabIndex: 2 }}
        style={{ marginTop: '15px' }}
        onCopy={(e) => {
          e.preventDefault();
          return false;
        }}
        onPaste={(e) => {
          e.preventDefault();
          return false;
        }}
      />
      <Typography fontSize={14} className={classes.helpText} style={{ marginTop: 10 }}>
        *Password should be at least 8 characters long containing a combination of uppercase, lowercase, numbers and
        special characters
      </Typography>
      <Button
        disabled={isLoading}
        color="primary"
        variant="contained"
        disableElevation
        fullWidth
        className={classes.buttonCls}
        onClick={() => form.handleSubmit()}
      >
        {isLoading ? <CircularProgress style={{ width: 25, height: 25 }} /> : 'Continue'}
      </Button>
    </Box>
  );
};

export default PasswordField;
